import { render } from "./ComponentContainer.vue?vue&type=template&id=4c4e5665"
import script from "./ComponentContainer.vue?vue&type=script&lang=js"
export * from "./ComponentContainer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\developement\\88ewm\\扫码端\\网页版\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__